import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { connect } from 'react-redux';

import changeScreen from 'actions/router';

import {
  Display,
  Content,
  Footer,
  HardwareButtonWrapper
} from 'containers';

import { MenuOption } from 'components';
import { DisplayButton } from 'components/buttons';

import styles from './Default.scss';

class Default extends Component {
  constructor(props) {
    super(props);

    const { passwordEntered } = this.props;
    const settingsPath = (passwordEntered) ? 'settings' : 'password';

    this.state = {
      selectedIndex: 0,
      destinations: [
        {
          icon: 'dashboard',
          path: 'meters'
        },
        {
          icon: 'wrench',
          path: 'service'
        },
        {
          icon: 'key',
          path: settingsPath
        }
      ],
      buttonConfig: {
        left: {
          destination: 'main'
        },
        center: {
          onClick: this.cycleOptions
        },
        right: {
          onClick: this.selectOption
        }
      }
    };
  }

  cycleOptions = () => {
    const { selectedIndex, destinations } = this.state;
    const totalItems = destinations.length;
    let newIndex = selectedIndex + 1;

    if (newIndex > totalItems - 1) {
      newIndex = 0;
    }

    this.setState({
      selectedIndex: newIndex
    });
  }

  selectOption = () => {
    const { navigateTo } = this.props;
    const { selectedIndex, destinations } = this.state;

    navigateTo(destinations[selectedIndex].path);
  }

  render() {
    const { selectedIndex, destinations, buttonConfig } = this.state;
    const selectedOption = destinations[selectedIndex];

    const options = destinations.map(item =>
      (<MenuOption
        key={uuidv4()}
        src={`icon-xm-${item.icon}`}
        selected={selectedOption && selectedOption.path === item.path}
      />));

    return [
      <Display key="display">
        <Content>
          <div className={styles.optionContainer}>
            {options}
          </div>
        </Content>
        <Footer>
          <DisplayButton src="icon-xm-close" />
          <DisplayButton src="icon-xm-cycle" />
          <DisplayButton src="icon-xm-enter" />
        </Footer>
      </Display>,
      <HardwareButtonWrapper key="buttons" config={buttonConfig} />
    ];
  }
}

Default.propTypes = {
  passwordEntered: PropTypes.bool.isRequired,
  navigateTo: PropTypes.func.isRequired
};

export default connect(({ workflow }) => ({
  passwordEntered: workflow.passwordEntered
}), {
  navigateTo: changeScreen
})(Default);



// WEBPACK FOOTER //
// ./src/screens/shared/Default/Default.js